import { useEffect, useState } from "react";
import { Card, CloseButton, Row, Col} from 'react-bootstrap'
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft, faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import { isMobile, isTablet } from 'react-device-detect';


const PDFsketchfab = ({pdfPlayer,setPDFplayer}) =>{
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
		setPageNumber(1);
	}

	const changePage = (offset) => {
		setPageNumber((prevPageNumber) => prevPageNumber + offset);
	}

	const previousPage = () => {
		changePage(-1);
	}

	const nextPage = () => {
		changePage(1);
	}

	useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    }, []);

	return(
    	<>
			<Card id="overlays" className=' border-0 rounded-0 p-1 m-1 align-items-center'>
				<CloseButton  onClick={() => setPDFplayer(null)} className='align-self-end bg-white p-2 border-4 btn-white rounded-circle p-1 m-1 position-absolute' />
				<Card.Body className='width-min-content align-items-center p-1 m-1 overflow-y'>
					<Row className=''>
						<Col xs={12} >
							<Document file={`pdf/${pdfPlayer}.pdf`} onLoadSuccess={onDocumentLoadSuccess} loading='Loading' className='custom-pdf-document' >
								{(isMobile || isTablet) ?
									<Page  devicePixelRatio={1} scale={0.4} pageNumber={pageNumber} />
								: 	<Page  devicePixelRatio={1} scale={0.84} pageNumber={pageNumber} />
								}
								
							</Document>
						</Col>
						{numPages && 
							<Col xs={12} className='pdf-page-number'>
								<button className=" bg-transparent p-0 m-0 border-0" disabled={pageNumber <= 1} onClick={previousPage}> <FontAwesomeIcon icon={faAnglesLeft} className='mx-2 bg-white p-1 m-1 rounded-circle' /> </button>
								<span className="pdf-footer-text text-white"> Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}</span>
								<button className=" bg-transparent p-0 m-0 border-0" disabled={pageNumber >= numPages} onClick={nextPage}><FontAwesomeIcon icon={faAnglesRight} className='mx-2 bg-white p-1 m-1 rounded-circle'/> </button> 
							</Col>
						}
					</Row>
				</Card.Body>
			</Card>

        </>
    )
}


export default PDFsketchfab;